<div *ngIf="!!matter" class="flex flex-col p-3 gap-1 overflow-hidden relative">
	<div *ngIf="mini; else expanded" class="flex items-center gap-3">
		<ng-container *ngTemplateOutlet="iconAndNumber"></ng-container>
		<ng-container
			*ngTemplateOutlet="
				matterName;
				context: { classes: 'whitespace-nowrap overflow-hidden text-ellipsis' }
			"
		></ng-container>
		<app-lawyer-clerk-initials
			*ngIf="clerkId || lawyerId"
			[lawyerId]="lawyerId"
			[clerkId]="clerkId"
			[testHook]="testHooks.LawyerClerkInitials"
		></app-lawyer-clerk-initials>
		<!-- status button -->
		<app-matter-status-tile [status]="matter.status"></app-matter-status-tile>
	</div>
</div>

<ng-template #expanded>
	<ng-container *ngTemplateOutlet="iconAndNumber"></ng-container>
	<div class="flex">
		<ng-container *ngTemplateOutlet="matterName"></ng-container>
	</div>
	<div class="contents" #content><ng-content></ng-content></div>
	<ng-container
		*ngIf="
			content?.children?.length && !address && (lawyerId || clerkId);
			else expandedView
		"
	>
		<!-- this is hacky, but it should be fine as long as the content isnt super wide -->
		<app-lawyer-clerk-initials
			class="absolute bottom-2 right-2"
			*ngIf="clerkId || lawyerId"
			[lawyerId]="lawyerId"
			[clerkId]="clerkId"
			[testHook]="testHooks.LawyerClerkInitials1"
		></app-lawyer-clerk-initials>
	</ng-container>

	<ng-template #expandedView>
		<div
			class="grid grid-rows-1 gap-2 items-center w-full"
			style="grid-template-columns: 1fr min-content"
		>
			<div class="flex flex-wrap gap-x-2 gap-y-1.5">
				<div
					class="text-xs text-grey truncate"
					[class.w-full]="condensed && !!(address | address: 'short')"
				>
					{{ address | address: 'short' }}
				</div>
				<div class="text-xs text-grey truncate">
					{{ address | address: 'cityProvinceCode' }}
				</div>
			</div>
			<app-lawyer-clerk-initials
				class="flex-none self-end"
				*ngIf="clerkId || lawyerId"
				[lawyerId]="lawyerId"
				[clerkId]="clerkId"
				[testHook]="testHooks.LawyerClerkInitials2"
			></app-lawyer-clerk-initials>
		</div>
	</ng-template>
</ng-template>

<ng-template #iconAndNumber>
	<div class="flex gap-3 items-center">
		<app-matter-type-icon [fileType]="matter.fileType"></app-matter-type-icon>

		<div
			*ngIf="
				matter.matterSource === MatterSource.LEAP ||
				matter.source === MatterSource.LEAP
			"
		>
			<img
				class="h-5 w-5 rounded"
				src="/assets/images/leap/leap-logo.png"
				alt="Leap"
			/>
		</div>

		<app-icon
			*ngIf="showOccupancyIcon"
			[icon]="ICON.FULL_PARCEL"
			class="text-xs text-grey-darker"
			[testHook]="testHooks.FullParcelIcon"
		></app-icon>
		<div *ngIf="showRequisitionData">
			<ng-container *ngTemplateOutlet="showRequisition"></ng-container>
		</div>
		<div *ngIf="showAppointmentData && matter?.appointment?.appointmentTime">
			<ng-container
				*ngTemplateOutlet="
					showAppointment;
					context: { time: matter.appointment.appointmentTime }
				"
			></ng-container>
		</div>
		<div class="text-sm truncate">#{{ matter.number }}</div>
	</div>
</ng-template>

<ng-template #matterName let-classes="classes">
	<div class="font-bold items-center text-sm flex-auto {{ classes || '' }}">
		{{ matter.name }}
	</div>
</ng-template>

<ng-template #showRequisition>
	<app-icon
		[icon]="ICON.CIRCLE_CHECK"
		class="text-lg"
		[matTooltip]="
			matter.fileType === MatterFiletype.PURCHASE
				? 'Requisition completed'
				: 'Title search completed'
		"
		*ngIf="matter?.requisitionStatus?.uploaded"
		[testHook]="testHooks.CircleCheckIcon"
	></app-icon>
	<app-icon
		class="text-lg"
		[matTooltip]="
			matter.fileType === MatterFiletype.PURCHASE
				? 'Requisition not completed'
				: 'Title search not completed'
		"
		*ngIf="!matter?.requisitionStatus?.uploaded"
		[icon]="ICON.CIRCLE_EXCLAMATION"
		[testHook]="testHooks.CircleExclamationIcon"
	></app-icon>
</ng-template>

<ng-template #showAppointment let-time="time">
	<app-icon
		[icon]="ICON.CLOCK"
		matTooltip="This appointment is at {{ time | date: 'h:mm a' }}"
		[testHook]="testHooks.ClockIcon"
	></app-icon>
</ng-template>
